export function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
}

export const stringMonthDate = (startDate, endDate) => {
  console.log(new Date(startDate).toString().split(' '));
  const [, startMonth, startDay, startYear] = new Date(startDate).toString().split(' ');
  //   if (startDate === endDate) return `${startMonth} ${startDay}, ${startYear}`;
  const [, endMonth, endDay, endYear] = new Date(endDate).toString().split(' ');
  // new Date(props);
  return `${startDay} ${startMonth} ${startYear} - ${endDay} ${endMonth} ${endYear}`;
};
